export const DESIGN_LIBRARY = '@processpuzzle/design';
